type RippleEvent = PointerEvent & KeyboardEvent

const TIMEOUT = 450

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('app-ripple', {
    mounted(element, binding) {
      if (binding.value === false) return

      element.addEventListener('mousedown', onListen)
      element.addEventListener('keydown', onListen)
    },
    beforeUnmount(element, binding) {
      if (binding.value === false) return

      element.removeEventListener('mousedown', onListen)
      element.removeEventListener('keydown', onListen)
    },
  })
})

// Слушаем событие клика и по координатам создаём элементы для риппл эффекта
const onListen = (event: RippleEvent) => {
  const target = event.currentTarget as HTMLElement

  let ripples: HTMLElement | null = null

  // Если это событие с клавиатуры, то центрируем
  if (event.type === 'keydown' && ['Enter', ' '].includes(event.key)) {
    ripples = createElement('50%', '50%')
  }

  // Если это событие мыши, то задаём координаты клика
  if (event.type === 'mousedown') {
    const rect = target.getBoundingClientRect()

    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    ripples = createElement(`${x}px`, `${y}px`)
  }

  if (ripples) {
    target.appendChild(ripples)

    setTimeout(() => ripples.remove(), TIMEOUT)
  }
}

// Создаём элементы для риппл эффекта
const createElement = (x: string, y: string) => {
  const parentElement = document.createElement('span')
  const childElement = document.createElement('span')

  parentElement.classList.add('ui-app-ripple')
  childElement.classList.add('ui-app-ripple__inner')

  childElement.style.left = x
  childElement.style.top = y

  parentElement.appendChild(childElement)

  return parentElement
}
